export default __webpack_public_path__ + "static/media/notification.7c390e06.svg";